// AdminLocationSettingsPage.js
import React, { useState } from "react";
import {
    Container,
    Typography,
    Paper,
    Box,
    Button,
    AppBar,
    Toolbar,
    Tabs,
    Tab,
    Divider,
} from "@mui/material";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import {
    ArrowBack as ArrowBackIcon,
    LocationOn as LocationOnIcon,
    QrCode as QrCodeIcon,
} from '@mui/icons-material';
import LocationManager from "../components/LocationManager";
import QRGenerator from "../components/QRGenerator";
import GeofenceManager from "../components/GeofenceManager";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`location-settings-tabpanel-${index}`}
            aria-labelledby={`location-settings-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const AdminLocationSettingsPage = ({ user, orgId }) => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleLogout = async () => {
        await signOut(auth);
        window.location.href = "/login";
    };

    const handleBack = () => {
        window.location.href = "/admin";
    };

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Button
                        color="inherit"
                        onClick={handleBack}
                        startIcon={<ArrowBackIcon />}
                        sx={{ mr: 2 }}
                    >
                        Back to Dashboard
                    </Button>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        TimeWarden Admin
                    </Typography>
                    <Button color="inherit" onClick={handleLogout}>Logout</Button>
                </Toolbar>
            </AppBar>

            <Container maxWidth="lg">
                <Paper sx={{ mt: 5, p: 4, borderRadius: 2, boxShadow: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <LocationOnIcon fontSize="large" sx={{ mr: 2, color: 'primary.main' }} />
                            <Typography variant="h4" component="h1">
                                Location Management
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ mb: 4 }} />

                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{ mb: 2 }}
                    >
                        <Tab
                            icon={<LocationOnIcon />}
                            label="Locations & Networks"
                            id="location-settings-tab-0"
                            aria-controls="location-settings-tabpanel-0"
                        />
                        <Tab
                            icon={<QrCodeIcon />}
                            label="QR Code Generator"
                            id="location-settings-tab-1"
                            aria-controls="location-settings-tabpanel-1"
                        />
                        <Tab
                            icon={<LocationOnIcon />}
                            label="Geofencing"
                            id="location-settings-tab-2"
                            aria-controls="location-settings-tabpanel-2"
                        />
                    </Tabs>

                    <TabPanel value={tabValue} index={0}>
                        <LocationManager
                            orgId={orgId}
                            userId={user.uid}
                        />
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <QRGenerator
                            orgId={orgId}
                            userId={user.uid}
                        />
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                        <GeofenceManager
                            orgId={orgId}
                            userId={user.uid}
                        />
                    </TabPanel>
                </Paper>
            </Container>
        </>
    );
};

export default AdminLocationSettingsPage;